import React, { useMemo } from "react";
import { Col, Form, Input, Row } from "antd";
import { FormItemInputId } from "../../common";
import "./SearchFiltersOrganization.less";
import { shortNames } from "../../../lib/const/shortsNames";

interface ComponentProps {
  displayedPropertyNames: string[];
}

export const SearchFiltersOrganization = (props: ComponentProps) => {
  const { displayedPropertyNames } = props;

  return (
    <div className="search-filters-organization">
      <Row gutter={50}>
        <Col span={12}>
          <Form.Item
            label="Полное наименование"
            name="organization.fullName"
            className="search-filters-organization__formItem"
          >
            <Input placeholder="Введите наименование" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Номер договора"
            name="agreementNumber"
            className="search-filters-organization__formItem"
          >
            <Input placeholder="Введите номер договора" allowClear />
          </Form.Item>
        </Col>
        {displayedPropertyNames.includes("inn") && (
          <Col span={12}>
            <Form.Item
              label="ИНН"
              name="inn"
              className="search-filters-organization__formItem"
              rules={[
                {
                  pattern: /^(|[1-9][0-9]*)$/,
                },
              ]}
            >
              <Input placeholder="Введите ИНН" maxLength={10} allowClear />
            </Form.Item>
          </Col>
        )}
        {displayedPropertyNames.includes("bin") && (
          <Col span={12}>
            <Form.Item
              label="БИН"
              name="bin"
              className="search-filters-organization__formItem"
              rules={[
                {
                  pattern: /^(|[1-9][0-9]*)$/,
                },
              ]}
            >
              <Input placeholder="Введите БИН" maxLength={12} allowClear />
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <FormItemInputId
            label="ID договоров"
            name="agreementIds"
            placeholder={`Введите ID договоров через ","`}
            className="search-filters-organization__formItem"
            allowClear
          />
        </Col>
        <Col span={12}>
          <Form.Item
            label={shortNames.externalId}
            name="subscriber.externalId"
            className="search-filters-organization__formItem"
          >
            <Input placeholder="Введите Тех. ID аккаунта" allowClear />
          </Form.Item>
        </Col>
        <Col span={12}>
          <FormItemInputId
            label="ID аккаунтов"
            name="accountIds"
            placeholder={`Введите ID аккаунтов через ","`}
            className="search-filters-organization__formItem"
            allowClear
          />
        </Col>
        {/* {displayedPropertyNames.includes("kpp") && (
          <Col span={12}>
            <Form.Item
              label="КПП"
              name="kpp"
              className="search-filters-organization__formItem"
              rules={[
                {
                  pattern: /^(|[1-9][0-9]*)$/,
                },
              ]}
            >
              <Input placeholder="Введите КПП" maxLength={9} />
            </Form.Item>
          </Col>
        )} */}
      </Row>
    </div>
  );
};
